import { XERO_INVOICE_HOST, XERO_INVOICE_PROTOCOL } from './constants';

export function xeroOnlineInvoiceUrl(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  let parsed: URL;
  try {
    parsed = new URL(value.trim());
  } catch {
    return null;
  }

  if (
    parsed.protocol !== XERO_INVOICE_PROTOCOL ||
    parsed.hostname !== XERO_INVOICE_HOST
  ) {
    return null;
  }

  return parsed.href;
}
